import { LexicalSerializeNode } from './lexicalSerialize.jsx'

export const articleRichTextPreset = {
  nodeClassNames: {
    heading: (node: LexicalSerializeNode) => {
      if (node.tag === 'h2') {
        return 'mt-300 sm:mt-600'
      }

      if (node.tag === 'h3') {
        return 'mt-200 sm:mt-400'
      }
    },
  },
}
